import { render, staticRenderFns } from "./MakeCopy.vue?vue&type=template&id=6c962a79"
import script from "./MakeCopy.vue?vue&type=script&lang=js"
export * from "./MakeCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports